import { useRouterState } from "@tanstack/react-router";
import {
  cn,
  greaterThanToday,
  parseDate,
  useAuthConfig,
} from "@theprelude/core";
import {
  Button,
  EditorIcon,
  ExceptionIcon,
  ToggleButton,
} from "@theprelude/ds";
import { useOverlay } from "@/hooks/use-overlay";
import { tb } from "@/lib/tracking";
import { useSetShowExcepted, useShowExcepted } from "@/queries/control-monitor";
import { exceptionsQuery } from "@/queries/exceptions";
import { ExceptionCount } from "./exception-count";

export function ExceptionVisibilitySwitcher() {
  const router = useRouterState();
  const overlay = useOverlay();

  const showExcepted = useShowExcepted();
  const setShowExcepted = useSetShowExcepted();

  const authConfig = useAuthConfig();
  const { data, isPending } = exceptionsQuery(authConfig).useQuery();

  const count = (data ?? []).filter(
    (e) => !e.expires || !greaterThanToday(parseDate(e.expires), 0),
  ).length;

  const disabled = !isPending && count === 0;

  const isViewingExceptions =
    router.location.search.overlay?.[0] === "exceptions";

  return (
    <Button
      intent="pill"
      icon={<ExceptionIcon className="text-secondary-foreground" />}
      onClick={() => {
        if (isViewingExceptions) {
          return overlay.close();
        }
        return overlay.open("exceptions", { filter: "all" });
      }}
      className={cn("relative gap-1", tb("exception-visibility-switch"))}
    >
      <ToggleButton
        checked={!showExcepted}
        disabled={disabled}
        onClick={(e) => e.stopPropagation()}
        onChange={(e) => setShowExcepted(!e.target.checked)}
      />
      <ExceptionCount count={count} />
      <span className="hidden md:block">Exceptions applied</span>
      <span className="hidden md:block">
        <EditorIcon className="text-secondary-foreground" />
      </span>
    </Button>
  );
}
